import Reviews from "../Components/Reviews";

function ReviewPage() {
  return (
    <div className="reviews">
      <Reviews />
    </div>
  );
}

export default ReviewPage;
